export default __webpack_public_path__ + "static/media/iconSearch.cfa82077.svg";